import { useEffect, useState } from "react";

const Header = (props) => {
  const [isDarkTheme, setIsDarkTheme] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Initialize theme based on local storage
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
      setIsDarkTheme(true);
    }
  }, []);

  useEffect(() => {
    if (isDarkTheme) {
      document.body.classList.add("darktheme");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("darktheme");
      localStorage.setItem("theme", "light");
    }

    updateIcon();
  }, [isDarkTheme]);

  function updateIcon() {
    const darkIcon = document.querySelector(".darkicon");
    if (darkIcon) {
      if (isDarkTheme) {
        darkIcon.classList.remove("fa-sun-o");
        darkIcon.classList.add("fa-moon-o");
      } else {
        darkIcon.classList.add("fa-sun-o");
        darkIcon.classList.remove("fa-moon-o");
      }
    }
  }

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
  };

  const menuToggle = () => {
    setIsMenuOpen((prev) => !prev);
    const navigation = document.getElementById("navigation");
    if (navigation) {
      navigation.classList.toggle("open", !isMenuOpen);
    }
    const hamburgers = document.querySelectorAll(".hamburger");
    hamburgers.forEach((hamburger) => {
      hamburger.classList.toggle("is-active", !isMenuOpen);
    });
  };

  return (
    <nav id="navbarscrollspy" className="header">
      <h2 className="logo">Portfolio</h2>

      {props.is404 === "true" ? (
        <></>
      ) : (
        <i onClick={toggleTheme} className="darkicon fa"></i>
      )}

      <div className="hamburger hamburger--emphatic-r" onClick={menuToggle}>
        <div className="hamburger-box">
          <div className="hamburger-inner"></div>
        </div>
      </div>

      <ul id="navigation" className={isMenuOpen ? "show" : ""}>
        {["Home", "About", "Resume", "Skills", "Projects", "Contact"].map(
          (item) => (
            <li key={item}>
              <a className="nav-link" onClick={menuToggle} href={`#${item}`}>
                {item}
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </a>
            </li>
          )
        )}
      </ul>
    </nav>
  );
};

export default Header;
